// TOUR-15 — AI Prompting suggest vs apply walkthrough (manager lane).

import type { FireflyTourArtifact } from "../tourTypes";

export const AI_PROMPTING_TOUR_ID = "tour-ai-prompting";

export const AI_PROMPTING_TOUR: FireflyTourArtifact = {
  id: AI_PROMPTING_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "ai prompting tour",
    "suggest prompt edit",
    "review ai suggestions",
    "how do i edit ai prompts",
    "prompt override tour",
    "ai prompt review queue",
    "change lead extract prompt",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "admin"],
  steps: [
    {
      id: "nav-ai-prompting",
      target: {
        mode: "aiPrompting",
        anchorId: "mode-nav-aiPrompting",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "aiPrompting",
      copy: {
        title: "Open AI Prompting",
        body: "Org-scoped prompt overrides live here under Manager. Tap AI Prompting in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "ap-surface",
      target: { mode: "aiPrompting", anchorId: "ap-surface", scrollIntoView: true },
      copy: {
        title: "Prompt editor",
        body: "Each card is a registered prompt key — lead extraction, coaching, and more as they migrate from the reference table below.",
      },
      advanceOn: "next_button",
    },
    {
      id: "prompt-stack",
      target: { mode: "aiPrompting", anchorId: "ap-prompt-stack", scrollIntoView: true },
      copy: {
        title: "Editable prompts",
        body: "Cards show the active text plus source pill — catalog default or org override. Review required prompts must go through the suggestion queue.",
      },
      advanceOn: "next_button",
    },
    {
      id: "suggest-edit",
      target: { mode: "aiPrompting", anchorId: "ap-suggest-edit", scrollIntoView: true },
      copy: {
        title: "Suggest edit",
        body: "Anyone with panel access can propose changes — your edit routes to trainers and owners for Accept, Reject, or Merge review.",
      },
      destructive: true,
    },
    {
      id: "review-queue",
      target: { mode: "aiPrompting", anchorId: "ap-review-queue", scrollIntoView: true },
      copy: {
        title: "Suggestion review",
        body: "Apply-capable roles open the suggestions pill when items are pending. Accept publishes the override, Merge hand-edits first, Reject dismisses — all from the inline diff tray.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "aiPrompting", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps never edit prompts here — consumption happens on Leads and Training surfaces. Ask Firefly anytime for Sales-mode tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
